package com.daytimegaming.ourdailyfinances

import kotlin.OptIn
import kotlin.String
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport

@JsExport
@OptIn(ExperimentalJsExport::class)
public object BuildKonfig {
  public val API_URL: String = "https://our-daily-finances-backend-production.up.railway.app"

  public val STAGING_API_URL: String = "https://our-daily-finances-backend-staging.up.railway.app"

  public val FIREBASE_PROJECT_ID: String = "ourdailyfinances"

  public val FIREBASE_APPLICATION_ID: String = "1:861129828943:web:6fef67d9b570aa877e183a"

  public val FIREBASE_API_KEY: String = "AIzaSyAPOICLHlGGgHDDEwNRRreQe5T8jqXiwuU"

  public val FIREBASE_AUTH_DOMAIN: String = "ourdailyfinances.firebasestorage.appm"

  public val FIREBASE_STORAGE_BUCKET: String = "ourdailyfinances.firebasestorage.app"

  public val GEOAPIFY_API_KEY: String = "a2df091caaf14bb0aedcf2a4dc72f613"

  public val SENTRY_DSN: String = ""

  public val SENTRY_AUTH_TOKEN: String = ""
}
